/** Estilos de tooltip do Recharts alinhados ao design system (claro/escuro). */
export const chartTooltipProps = {
  contentStyle: {
    background: 'hsl(var(--popover))',
    border: '1px solid hsl(var(--border))',
    borderRadius: 12,
    fontSize: 12,
    color: 'hsl(var(--popover-foreground))',
  },
  itemStyle: {
    color: 'hsl(var(--popover-foreground))',
  },
  labelStyle: {
    color: 'hsl(var(--popover-foreground))',
  },
} as const;

export const chartLegendStyle = {
  fontSize: 12,
  color: 'hsl(var(--foreground))',
} as const;

export const chartAxisTick = {
  fontSize: 12,
  fill: 'hsl(var(--muted-foreground))',
} as const;
